import { inject, Injectable } from '@angular/core';
import { UserApiService } from './api/user-api.service';
import { map, Observable } from 'rxjs';
import { UserInfo } from '../types/user.type';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private userApiService = inject(UserApiService);

  userInfo(): Observable<UserInfo> {
    return this.userApiService
      .userInfo()
      .pipe(map(({ result }) => result || ({} as UserInfo)));
  }

  updateUserInfo(sendEmail: boolean): Observable<void> {
    return this.userApiService
      .updateUserInfo(sendEmail)
      .pipe(map(({ result }) => result));
  }
}
